import React, { useState, useContext, useEffect } from 'react'
import SidebarApp from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer'
import { Light, Dark } from '../styles/Themes';
import StickyBox from 'react-sticky-box';
import { Outlet, useNavigate } from 'react-router-dom';// desde la V6 es routes no switch
import { useCasUserContext } from '../../services/casUserContext';
import NavMenu from '../Navbar/Navbar';
import { ModalOrcId } from '../Modal/ModalOrcId';
import { ModalScholar } from '../Modal/ModalScholar';
import { Container, Grid, LinearProgress, Stack } from '@mui/material';
import logoespol from '../../recursos_iconos/Portal_Investigacion_r.svg';
import { getImageFromDB } from '../../helpers/imageDB';
import { useMsal } from '@azure/msal-react';

interface Props {
  isSecure?: false
}

export const ThemeContext = React.createContext(null);

const styles = {
  contentDiv: {
    display: "flex",
  },
  contentMargin: {
    marginLeft: "0px",
    width: "100%",
  },
};

export default function LayoutInterno(props: Props) {

  const [theme, setTheme] = useState("light")
  const themeStyle = theme === "light" ? Light : Dark;
  const navigate = useNavigate();
  const [b, setB] = useState<boolean>(true)
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const currentPath = window.location.pathname;
  //const cas = useCas(b);
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalOpenScholar, setModalOpenScholar] = useState<boolean>(false);
  const [menuVisible, setMenuVisible] = useState(true);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const abrirModal = (estado: boolean) => {
    setModalOpen(estado);
  };

  const cerrarModal = (estado: boolean) => {
    setModalOpen(estado);
  };

  const abrirModalScholar = (estado: boolean) => {
    setModalOpenScholar(estado);
  };

  const cerrarModalScholar = (estado: boolean) => {
    setModalOpenScholar(estado);
  };

  const fetchImage = async () => {
    // Recupera la imagen de IndexedDB
    const cachedImage = await getImageFromDB('profile-pic');
    if (cachedImage) {
      setImageSrc(`${cachedImage}`);
    }
  };

  useEffect(() => {
    if (casUserContext.user) {
      fetchImage();
      navigate(currentPath);
    }
  }, [casUserContext.user]);

  if (casUserContext.checking) {
    return (
      <div>
        <div className='centrado' style={{ paddingTop: '25px', paddingBottom: '25px', borderBottom: '2px solid #243165' }} >
          <img className='imgBox' width='350px' height='auto' src={logoespol} alt="" style={{ marginLeft: '10%' }} onClick={() => { navigate('/inicio/portalinvestigacion') }} />
        </div>
        <Container maxWidth="lg" style={{ paddingTop: '50px', paddingBottom: '50px' }}>
          <div className='wrapper'>
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
              <LinearProgress color="secondary" />
            </Stack>
          </div>
        </Container>
      </div>
    ); // Mostrar un indicador de carga mientras se obtienen los datos
  }

  return (
    <div className='wrapper' >
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <div className='main-panel' style={styles.contentMargin}>
          <div style={{ paddingLeft: menuVisible ? '1vw' : '0', paddingRight: '1vw', paddingTop: '1vh', paddingBottom: '1vh', minHeight: '90vh' }}>
            <StickyBox className='app-navbar' offsetBottom={20} >
              <div>
                <NavMenu
                  nombreApp=''
                  apellidos={casUserContext.userData.apellidos}
                  nombres={casUserContext.userData.nombres}
                  foto={imageSrc ?? ''}
                  userFlag={casUserContext.user}
                  abrirModal={abrirModal}
                  abrirScholar={abrirModalScholar}
                />
              </div>
            </StickyBox>
            <div className="app-container">
              {casUserContext.user ?
                <div className='app-sidebar' >
                  <SidebarApp idInv={casUserContext.userData.idinv} roles={casUserContext.userData.roles} />
                </div>
                : <></>
              }
              {/*children*/}
              <div className="app-content">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
      {true ? <></> : <ModalOrcId isOpen={modalOpen} cerrarModal={cerrarModal} />}
      {true ? <></> : <ModalScholar isOpen={modalOpenScholar} cerrarModal={cerrarModalScholar} />}
    </div>

  );
}
